(() => {
  'use strict';
  const node = document.getElementById('MMExternalSettings');
  const catalog = window.MMExternalCatalog;
  if (!node || !catalog) return;
  const settings = JSON.parse(node.textContent), strings = settings.strings;
  // Campaign handoff: allowlisted values only, with Shopify consent respected.
  // This transports attribution data; it does not create Meta events or cookies.
  const attributionKey = 'mm_checkout_attribution_v1';
  const attributionLifetime = 24 * 60 * 60 * 1000;
  const attributionNames = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_content', 'utm_term', 'utm_id', 'utm_source_platform', 'utm_creative_format', 'utm_marketing_tactic', 'fbclid'];
  const landingParams = new URLSearchParams(window.location.search);
  const cleanAttribution = values => {
    const clean = {};
    attributionNames.forEach(name => {
      const value = values?.[name];
      if (typeof value === 'string' && value.length && value.length <= (name === 'fbclid' ? 2048 : 500) && !/[\u0000-\u001f\u007f]/.test(value)) clean[name] = value;
    });
    return clean;
  };
  const incomingAttribution = cleanAttribution(Object.fromEntries(landingParams));
  const hasIncomingAttribution = Object.keys(incomingAttribution).length > 0;
  const allowedAttribution = values => {
    const privacy = window.Shopify?.customerPrivacy;
    const analyticsAllowed = privacy?.analyticsProcessingAllowed?.() === true;
    const marketingAllowed = privacy?.marketingAllowed?.() === true;
    return Object.fromEntries(Object.entries(cleanAttribution(values)).filter(([name]) => name === 'fbclid' ? marketingAllowed : analyticsAllowed));
  };
  const checkoutAttribution = () => {
    try {
      // Wait for the privacy API before reading or persisting campaign storage.
      if (!window.Shopify?.customerPrivacy) return {};
      let saved;
      try { saved = JSON.parse(window.sessionStorage.getItem(attributionKey) || 'null'); } catch (_) {}
      const now = Date.now();
      const validSaved = saved && Number.isFinite(saved.capturedAt) && now >= saved.capturedAt && now - saved.capturedAt < attributionLifetime;
      // A new tagged visit replaces the previous campaign, avoiding mixed UTMs.
      const params = allowedAttribution(hasIncomingAttribution ? incomingAttribution : validSaved ? saved.params : {});
      try {
        if (Object.keys(params).length) window.sessionStorage.setItem(attributionKey, JSON.stringify({capturedAt: hasIncomingAttribution ? now : saved.capturedAt, params}));
        else window.sessionStorage.removeItem(attributionKey);
      } catch (_) { /* Checkout still works when browser storage is unavailable. */ }
      return params;
    } catch (_) { return {}; }
  };
  document.addEventListener('visitorConsentCollected', checkoutAttribution);
  if (window.Shopify?.customerPrivacy) checkoutAttribution();
  else if (window.Shopify?.loadFeatures) {
    window.Shopify.loadFeatures([{name: 'consent-tracking-api', version: '0.2'}], error => { if (!error) checkoutAttribution(); });
  }
  const entryFor = id => catalog.variants[String(id)];
  const retiredRiceVariants = new Set(['67884636766574', '67898129547630']);
  const changedRiceMessage = 'This kit has changed. Remove it and choose your kit again.';
  const money = cents => new Intl.NumberFormat(document.documentElement.lang || 'en', { style: 'currency', currency: settings.currency }).format(cents / 100);
  const text = (tag, content) => { const el = document.createElement(tag); el.textContent = content; return el; };
  const prepareSourceBody = body => {
    if (retiredRiceVariants.has(String(body.get('id')))) throw new Error(changedRiceMessage);
    const entry = entryFor(body.get('id'));
    if (!entry) throw new Error(strings.missing);
    const plan = body.get('selling_plan');
    body.delete('properties[_lpm_selling_plan]');
    if (plan) {
      if (String(plan) !== entry.plan) throw new Error(strings.error);
      body.set('properties[_lpm_selling_plan]', plan);
      body.delete('selling_plan');
    }
  };
  const linePrice = item => {
    const entry = entryFor(item.variant_id);
    if (entry?.priceIncludesSubscription === true) return item.final_line_price;
    return item.properties?._lpm_selling_plan && entry?.plan === String(item.properties._lpm_selling_plan) ? Math.round(item.original_price * .75) * item.quantity : item.final_line_price;
  };
  const subtotal = cart => cart.total_price - cart.items.reduce((sum, item) => sum + item.final_line_price - linePrice(item), 0);
  window.MMExternalCheckout = Object.freeze({ prepareSourceBody, linePrice, subtotal, strings });
  const notice = form => {
    if (form.querySelector('[data-lpm-notice]')) return;
    const el = text('p', strings.notice); el.dataset.lpmNotice = ''; el.className = 'mm-product-form-status'; form.append(el);
  };
  const initialize = (scope = document) => {
    scope.querySelectorAll('.mm-product-form,.mm-ritual-form,[data-cart-form]').forEach(notice);
    scope.querySelectorAll('[data-mm-product-data]').forEach(script => {
      if (script.dataset.lpmReady) return;
      script.dataset.lpmReady = 'true';
      const data = JSON.parse(script.textContent);
      data.variants.forEach(variant => {
        const entry = entryFor(variant.id);
        if (!entry?.plan) return;
        const price = Math.round(variant.price * .75);
        variant.plans = [{ id: entry.plan, name: strings.refills, terms: strings.terms, price, priceText: money(price), compare: variant.price, compareText: variant.priceText }];
      });
      script.textContent = JSON.stringify(data);
      const root = script.closest('[data-mm-product]'), form = root.querySelector('.mm-product-form');
      if (data.variants.some(variant => entryFor(variant.id)?.plan) && !form.querySelector('[data-mm-plan]')) {
        const wrapper = document.createElement('div'); wrapper.className = 'mm-product-field'; wrapper.dataset.mmPlansWrapper = '';
        const label = document.createElement('label'); label.className = 'mm-refill-switch';
        const select = document.createElement('select'); select.name = 'selling_plan'; select.dataset.mmPlan = ''; select.id = form.id + '-LPMPlan'; select.hidden = true;
        const current = data.variants.find(variant => String(variant.id) === form.querySelector('[name=id]').value);
        select.add(new Option(data.strings.oneTime, ''));
        current?.plans.forEach(plan => select.add(new Option(plan.name + ' — ' + plan.priceText, plan.id)));
        if (current?.plans[0]) select.value = current.plans[0].id;
        const toggle = document.createElement('input'); toggle.type = 'checkbox'; toggle.setAttribute('role', 'switch'); toggle.checked = !!select.value; toggle.dataset.mmRefillToggle = '';
        const copy = text('span', strings.refills); label.append(toggle, copy);
        toggle.addEventListener('change', () => { select.value = toggle.checked ? entryFor(form.querySelector('[name=id]').value)?.plan || '' : ''; select.dispatchEvent(new Event('change', { bubbles: true })); });
        select.addEventListener('change', () => { toggle.checked = !!select.value; });
        const terms = text('p', strings.terms); terms.dataset.mmPlanTerms = '';
        wrapper.append(label, select, terms); form.querySelector('.mm-product-buy-row').before(wrapper);
      }
    });
    scope.querySelectorAll('[data-ritual]').forEach(root => {
      const data = JSON.parse(root.querySelector('[data-ritual-variants]')?.textContent || '[]');
      root.querySelectorAll('[data-ritual-options]').forEach(fieldset => {
        if (fieldset.dataset.lpmReady) return;
        const variant = data.find(v => String(v.id) === fieldset.dataset.ritualOptions), entry = entryFor(variant?.id);
        if (!entry?.plan) return;
        fieldset.dataset.lpmReady = 'true';
        fieldset.querySelectorAll('.mm-plan-coming,.mm-automatic-refills').forEach(el => el.remove());
        fieldset.querySelectorAll('input[type=radio]').forEach(input => { input.checked = false; });
        const price = money(Math.round(variant.price * .75));
        const label = document.createElement('label'); label.className = 'mm-ritual-option mm-automatic-refills';
        const input = document.createElement('input'); input.type = 'radio'; input.name = fieldset.querySelector('input')?.name || ('lpm-' + variant.id); input.value = entry.plan; input.dataset.price = price; input.dataset.terms = strings.terms; input.checked = true;
        const copy = document.createElement('span'); copy.append(text('strong', strings.refills), text('small', strings.terms));
        label.append(input); label.hidden = true;
        fieldset.querySelectorAll('label.mm-ritual-option').forEach(option => { option.hidden = true; });
        const switchLabel = document.createElement('label'); switchLabel.className = 'mm-refill-switch mm-ritual-option mm-automatic-refills';
        const toggle = document.createElement('input'); toggle.type = 'checkbox'; toggle.setAttribute('role', 'switch'); toggle.checked = true; toggle.dataset.mmRefillToggle = '';
        switchLabel.append(toggle, copy);
        toggle.addEventListener('change', () => {
          root.querySelectorAll('[data-ritual-options]').forEach(options => {
            const sibling = options.querySelector('[data-mm-refill-toggle]');
            sibling.checked = toggle.checked;
            sibling.closest('label').querySelector('small').textContent = toggle.checked ? strings.terms : strings.no_recurring;
            options.querySelectorAll('input[type=radio]').forEach(radio => { radio.checked = toggle.checked ? !!radio.value : !radio.value; });
          });
        });
        fieldset.querySelector('legend')?.after(label, switchLabel);
        const consent = root.querySelector('[data-ritual-consent]');
        if (consent?.nextElementSibling) consent.nextElementSibling.textContent = strings.consent;
      });
    });
    scope.querySelectorAll('[data-ritual-cart] footer').forEach(footer => {
      if (footer.querySelector('[data-lpm-notice]')) return;
      const el = text('p', strings.notice + ' ' + strings.estimate); el.dataset.lpmNotice = ''; footer.prepend(el);
    });
  };
  initialize();
  document.addEventListener('shopify:section:load', event => initialize(event.target));
  let busy = false;
  const transfer = async (status, note) => {
    if (busy) return;
    busy = true;
    try {
      status.textContent = strings.continuing;
      const response = await fetch(settings.root + 'cart.js', { headers: { Accept: 'application/json' } });
      if (!response.ok) throw new Error(strings.error);
      const cart = await response.json();
      if (!cart.items?.length) throw new Error(strings.empty);
      const attribution = checkoutAttribution();
      const attributionQuery = new URLSearchParams(attribution).toString();
      const fields = { return_to: '/checkout' + (attributionQuery ? '?' + attributionQuery : '') };
      if (note || cart.note) fields.note = note ?? cart.note;
      cart.items.forEach((item, index) => {
        if (retiredRiceVariants.has(String(item.variant_id))) throw new Error(changedRiceMessage);
        const entry = entryFor(item.variant_id);
        if (!entry || !Number.isSafeInteger(item.quantity) || item.quantity < 1) throw new Error(strings.missing);
        const plan = item.properties?._lpm_selling_plan || item.selling_plan_allocation?.selling_plan?.id;
        if (plan && String(plan) !== entry.plan) throw new Error(strings.error);
        fields[`items[${index}][id]`] = entry.id;
        fields[`items[${index}][quantity]`] = String(item.quantity);
        if (plan) fields[`items[${index}][selling_plan]`] = String(plan);
        Object.entries(item.properties || {}).forEach(([key, value]) => {
          if (!key.startsWith('_lpm_') && !key.startsWith('_vc_attribution_')) fields[`items[${index}][properties][${key}]`] = String(value);
        });
        // Private line properties remain attached to the destination cart/order.
        Object.entries(attribution).forEach(([key, value]) => {
          fields[`items[${index}][properties][_vc_attribution_${key}]`] = value;
        });
      });
      const outgoing = document.createElement('form'); outgoing.method = 'post'; outgoing.action = catalog.origin + '/cart/add' + (attributionQuery ? '?' + attributionQuery : ''); outgoing.hidden = true;
      Object.entries(fields).forEach(([name, value]) => { const input = document.createElement('input'); input.type = 'hidden'; input.name = name; input.value = value; outgoing.append(input); });
      document.body.append(outgoing); HTMLFormElement.prototype.submit.call(outgoing);
      window.addEventListener('pageshow', () => { busy = false; status.textContent = ''; }, { once: true });
      window.setTimeout(() => {
        if (document.visibilityState === 'visible' && busy) {
          status.textContent = strings.navigation_error;
          status.setAttribute('role', 'alert');
          status.tabIndex = -1; status.focus();
        }
      }, 15000);
    } catch (error) { busy = false; status.textContent = error.message || strings.error; status.setAttribute('role', 'alert'); status.tabIndex = -1; status.focus(); }
  };
  document.addEventListener('submit', event => {
    if (!event.target.matches('[data-cart-form]') || event.submitter?.name !== 'checkout') return;
    event.preventDefault(); event.stopImmediatePropagation();
    const root = event.target.closest('[data-mm-cart]');
    if (root.getAttribute('aria-busy') === 'true') return;
    transfer(root.querySelector('[data-cart-status]'), event.target.querySelector('[name=note]')?.value);
  }, true);
  document.addEventListener('click', event => {
    const link = event.target.closest('[data-ritual-cart] footer a');
    if (!link || !new URL(link.href).pathname.endsWith('/checkout')) return;
    event.preventDefault(); event.stopImmediatePropagation();
    const root = link.closest('[data-ritual-cart]');
    if (root.getAttribute('aria-busy') === 'true') return;
    transfer(root.querySelector('[data-cart-status]'));
  }, true);
})();
